import General from './components/General';
import MobileNav from './components/MobileNav';

// Dynamically import all script.ts files from blocks and components
const requireContextBlocks = require.context('../../blocks', true, /src\/js\/script\.ts$/);
const requireContextComponents = require.context('../../components', true, /src\/js\/script\.ts$/);

requireContextBlocks.keys().forEach((key) => {
	requireContextBlocks(key);
});

requireContextComponents.keys().forEach((key) => {
	requireContextComponents(key);
});

/**
 * Controller class.
 *
 * Standardizes how we hook into event listeners and create components.
 */
class Controller {
	constructor() {
		this.init();

		window.addEventListener('resize', this.resized);
		window.addEventListener('load', this.loaded);
	}

	init() {
		General.init();
		MobileNav.init();
	}

	// eslint-disable-next-line @typescript-eslint/no-empty-function, prettier/prettier
	resized() {
		MobileNav.removeOpenMenuClasses();
		MobileNav.vhMobileHeight();
	}

	// eslint-disable-next-line @typescript-eslint/no-empty-function
	loaded() {}
}

// Run controller.
new Controller();
